
import { Component, Prop, Vue } from "vue-property-decorator";
import store from "../../core/store";
import { Format } from "@shared/core/helpers/formatHelper";
import ScrollableBanner from "@shared/crm/components/scrollableBanner.vue";

@Component({
  components: {
    ScrollableBanner,
  },
})
export default class BookingTypesBanner extends Vue {
  @Prop({ required: true }) private bookingTypes!: any[];
  private images: any[] = [];

  async mounted() {
    this.setDefaultImages();
  }

  private setDefaultImages() {
    const context = require.context(
      "@/images/bookingtypes",
      false,
      /\.(png|jpe?g|webp|gif)$/
    );
    this.images = context.keys().map(context);
  }

  private getImageType(name: string, index: number) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return this.images[index % this.images.length];
  }

  private getPrice(pr: any) {
    return this.formatText(
      store.state.settings.PriceWithTaxes ? pr.grossPrice : pr.netPrice
    ).trimEnd();
  }

  private formatText(amount: string | null) {
    if (amount == null) {
      return "   ";
    }
    return this.$t("From") + " " + Format.formatCurrency(amount as string);
  }
}
